import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { CenteredPage } from '../../components/layout/CenteredPage';
import { Button } from '../../components/actions/Button';

/**
 * Reached when a request fails for lack of network, or the browser fires
 * `offline`. Leaves on its own the moment the browser reports `online` —
 * back to wherever the user was, or home.
 */
export function NoNetworkPage() {
  const { t } = useTranslation('common');

  useEffect(() => {
    const leave = () => {
      if (window.history.length > 1) window.history.back();
      else window.location.assign('/');
    };
    // `online` only fires on a change; a refresh with the network back needs this.
    if (navigator.onLine) {
      leave();
      return;
    }
    window.addEventListener('online', leave);
    return () => window.removeEventListener('online', leave);
  }, []);

  return (
    <CenteredPage
      title={t('pages.noNetwork.title')}
      actions={
        <Button fullWidth onClick={() => navigator.onLine && window.history.back()}>
          {t('actions.retry')}
        </Button>
      }
    >
      {t('pages.noNetwork.body')}
    </CenteredPage>
  );
}
